const catalogCards = document.querySelectorAll(".js-catalog-card");

window.addEventListener("load", initCharacteristicsModal());

function initCharacteristicsModal() {
    if (catalogCards.length > 0) {
        catalogCards.forEach((item) => {
            const characteristicsModal = item.querySelector(".js-catalog-card-characteristics");
            const characteristicsOpen = item.querySelector(".js-characteristics-open");
            const characteristicsClose = item.querySelector(".js-characteristics-close");
            const buttons = [characteristicsOpen, characteristicsClose];
            function toggleModal() {
                if (!characteristicsModal.classList.contains("active")) {
                    characteristicsModal.classList.add("active");
                } else {
                    characteristicsModal.classList.remove("active");
                }
            }
            for (const button of buttons) {
                button.addEventListener("click", () => {
                    toggleModal();
                });
            }
        });
    }
}
